<template>
  <div v-show="$route.meta.navShow == undefined || $route.meta.navShow">
    <ul>
      <li >
        <router-link to="/search" tag="div">
          <img
            :src="this.$route.path == '/search' ? imgurl.index1 : imgurl.index2"
          />
          酒店预订
        </router-link>
      </li>
      <li>
        <router-link to="/center" tag="div">
          <img
            :src="
              this.$route.path == '/center' ? imgurl.goods1 : imgurl.goods2
            "
          />
          个人中心
        </router-link>
      </li>
    </ul>

    <div class="bouncedpage" v-if="isshow">
      <div class="bouncebox">
        <div v-show="showTitle" class="tips">提示</div>
        <div class="text">{{msg}}</div>
        <div class="btn">
          <div class="right" @click="determine">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      canhotelbooking: null,
      canUserCount: null,
      canbooking: null,
      imgurl: {
        index1: " ../static/images/tab_icon_yuding_sele.svg",
        index2: " ../static/images/tab_icon_yuding_default.svg",
        goods1: " ../static/images/tab_icon_per_sele.svg",
        goods2: " ../static/images/tab_icon_per_default.svg"
      },
      windowHeight: 0,
      isshow: false
    };
  },
  components: {
  },
  created() {
    
  },
  methods: {
    temporaryRepair() {
      let that = this;
      let windowFocusHeight = window.innerHeight;
      if (that.windowHeight == windowFocusHeight) {
        return;
      }
      let currentPosition;
      let speed = 1; //页面滚动距离
      currentPosition =
        document.documentElement.scrollTop || document.body.scrollTop;
      currentPosition -= speed;
      window.scrollTo(0, currentPosition); //页面向上滚动
      currentPosition += speed; //speed变量
      window.scrollTo(0, currentPosition); //页面向下滚动
    }
  },
  watch: {
    $route(to, from) {
      if (from.name == "loginpage") {
      }
    }
  }
};
</script>
<style type="text/css" scoped>
ul {
  width: 100%;
  height: 49px;
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #ededed;
  background: #ffffff;
  z-index: 99;
}
ul li {
  width: 33.3333%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 400;
  color: rgba(146, 148, 157, 1);
}
ul li div {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
ul li div img {
  width: 20px;
  height: 20px;
}
.router-link-active {
  color: #ff5e24;
}

.bouncedpage {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
}
.bouncebox {
  background: #fff;
  width: 207px;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
}
.bouncebox .text {
  color: #191919;
  font-size: 15px;
  font-weight: 400;
  display: flex;
  justify-content: center;
  padding-top: 5px;
  margin: 12px;
}
.bouncebox .btn {
  display: flex;
  align-items: center;
  border-top: 1px solid #ededed;
  justify-content: center;
}
.bouncebox .btn .right {
  width: 70px;
  height: 40px;
  border-radius: 3px;
  align-items: center;
  display: flex;
  justify-content: center;
  font-size: 12px;
  font-weight: 400;
  color: #ff5e24;
}
.bouncebox .tips {
  text-align: center;
  font-size: 1632px;
  padding-top: 7px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/views/tabs/tabs.vue